/**
 * True when advertiser kpiSummary has primary KPI and monthly volume target set.
 */
export const isGlobalReportKpiGoalsConfigured = (kpiSummary) => {
  if (!kpiSummary || typeof kpiSummary !== "object") {
    return false;
  }

  const primaryKpi =
    typeof kpiSummary.primaryKpi === "string"
      ? kpiSummary.primaryKpi.trim()
      : "";
  const volume = Number(kpiSummary.volume);

  return Boolean(primaryKpi) && Number.isFinite(volume) && volume > 0;
};

export default isGlobalReportKpiGoalsConfigured;
